import '../scss/styles.scss';
import './custom_elements/rsce_cs_004_hero';
import './custom_elements/rsce_gallery_slider';
import accordion from './module/accordion'
import navigation from './module/navigation'
// import cookiebanner from './module/cookiebanner'
import carousel from './module/carousel'
import './module/webcomponents-loader';
//import './module/model-viewer';
import './module/effects';
import './module/counterup'; 
import custom from './module/custom'